import React from "react";
import { Box, Button, Stack } from "@mui/material";
import { Title, Text } from "./style";
import HeroImg from "../../images/managekaro hero.png";
import { Link } from "react-router-dom";

function HomeSection() {
  return (
    <Box sx={{ minHeight: "60vh", pt: "60px", pb: "20px" }}>
      <Stack direction={{ xs: "column-reverse", md: "row" }}>
        <Stack
          direction="column"
          justifyContent={{ xs: "center", md: "space-between" }}
          alignItems={{ xs: "center", md: "flex-start" }}
          minHeight="374px"
          spacing={2}
        >
          <Title sx={{ color: "#60656C" }}>
            Smartest Business Management Portal
          </Title>
          <Text>
            Manage your business professionally with ManageKaro through the best
            Web and Mobile Apps for your billing, inventory, accounting
            etc. Join the digital revolution and bring your business online.
          </Text>
          <Link to="/inventory/login">
            <Button
              variant="contained"
              sx={{
                fontFamily: "Poppins",
                px: { xs: "10px 20px", md: "50px" },
              }}
            >
              Access Now
            </Button>
          </Link>
        </Stack>

        <Box>
          <img style={{ maxWidth: "100%" }} src={HeroImg} alt="" />
        </Box>
      </Stack>
    </Box>
  );
}

export default HomeSection;
